import React from 'react';
import TextField from '@mui/material/TextField';
import { connect } from 'react-redux';
import setStreetAction from '../../redux/actions/createReferenceActions/actionStreet';
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: "rgb(0,191,255)",
      },
      '&.Mui-focused': {
        borderColor: "rgb(47, 79, 79)",
      },
    },
    '& .Mui-focused': {
      color: 'white',
    },
    width: 300,
    marginTop: 10,
    fontSize: 30,
    backgroundColor: 'rgba(19, 174, 236, 0.54)',
    fontWeight: 'bold'
  });

class StreetForm extends React.Component {

    constructor(props) {
        super(props);

        if (this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
            this.state = { street: this.props.selectedReferenceData.street };
            this.props.setStreetFunction(this.state.street)
        } else {
            this.state = { street: '' };
            this.props.setStreetFunction('defaultStreet')
        }
    }

    shouldComponentUpdate(nextProps, nextState) {

        if (this.state.street !== nextProps.street) {
            this.setState({ street: nextProps.street})
            return false;
        } else {
            return true;
        }
    }

    render() {

        const { t } = this.props;
        return (
            <div>
            <StyledTextField key={this.props.searchVal} disabled={true}  value={this.state.street} inputProps={{ maxLength: 30, style: {fontWeight: 'bold'} }} label={t('create_ref.street') + "*"} variant="outlined"
               style={{ width: 300, marginBottom: 10, marginTop: 10, fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}/>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        selectedReferenceData: state.showRefState.selectedReferenceData
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setStreetFunction: street => {
            dispatch(setStreetAction(street))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StreetForm));